export default __webpack_public_path__ + "static/media/expressjs.04e4743f.png";